import {useEffect} from 'react'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import {appLog_recordPageView_Api} from 'apis'

// Khớp Common::$pageViewKeys (backend). Chỉ các trang landing/danh sách không gắn record cụ thể
// (không trùng với total_views theo item đã có ở API controller riêng, vd church/$id, song/$id...).
const PATHNAME_TO_PAGE_KEY = {
  '/': 'home',
  '/home': 'home',
  '/apps': 'apps',
  '/bibles': 'bibles',
  '/prayer-books': 'prayer_books',
  '/prayers': 'prayers',
  '/mass-times': 'mass_times',
  '/churches': 'churches',
  '/news': 'news_channels',
  '/dioceses': 'dioceses',
  '/religious-orders': 'religious_orders',
  '/profiles': 'profiles',
  '/search': 'search',
  '/organizations': 'organizations',
  '/products': 'products',
  '/missals': 'missals',
  '/musics': 'musics',
  '/hymns': 'hymns',
  '/ecclesiastics': 'ecclesiastics',
  '/definitions': 'definitions',
  '/asks': 'asks',
  // /discussions thay thế /asks (hub mới) - dùng chung page_key backend 'asks' để không tách rời số liệu.
  '/discussions': 'asks',
  // "Kristo Edu" - URL đổi từ /courses sang /edu, GIỮ NGUYÊN giá trị 'courses' (khớp
  // Common::$pageViewKeys phía backend, không đổi vì đây là mã tracking nội bộ, không cần khớp URL).
  '/edu': 'courses',
  '/liturgies': 'liturgies',
  '/journey-to-christ': 'journey_to_christ',
  '/catholic-households': 'catholic_households',
  '/evangelization': 'evangelization',
  '/pilgrimage': 'pilgrimage',
  '/examinations': 'examinations',
  '/yellow-pages': 'yellow_pages',
  '/spiritual-path': 'spiritual_path',
  '/spiritual-exercises': 'spiritual_exercise',
  '/spiritual-journal': 'spiritual_journal',
  '/spiritual-examen': 'spiritual_examen',
  '/spiritual-discernment': 'spiritual_discernment',
  '/devotions': 'devotions',
  '/prayer-methods': 'prayer_methods',
  '/calendar': 'calendar',
  '/discovery': 'directory',
}

const PageViewTracker = ({value, children = null}) => {
  const {handleAsyncAction} = useAsyncAction({apiInfo: appLog_recordPageView_Api})

  useEffect(() => {
    const pageKey = PATHNAME_TO_PAGE_KEY[value]
    if (pageKey) {
      handleAsyncAction({page_key: pageKey})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return children
}
export default PageViewTracker
